// import PropTypes from 'prop-types';
import styles from './ArtistNameList.module.scss';

const ArtistNameList = ({ artists }) => {

    return (
        <div className={styles['ArtistNameList']}>
            <div className={styles['ArtistNameList__Container']}>
                {artists?.map((artist, i) => (
                    <span key={i} className={styles['ArtistNameList__Item']}>
                        {artist}
                    </span>
                ))}
            </div>
        </div>
    );
};

ArtistNameList.propTypes = {};

export default ArtistNameList;
